import { isEmpty } from '@nirvana/shared/basic-types/object';
import { RowRightClickEvent } from '../gridView/types';
import { GridEvents } from '../types/common';
import { WebComponentEvent } from '../../framework/BaseWebComponentController';
import { GridViewController } from '../gridView/controller/GridViewController';

export function onRowRightClickEvent<GridItemType>(
  gridController: GridViewController<number, string>,
  event: WebComponentEvent
): void {
  event.preventDefault();
  if (!gridController.component.hasSelectableRows) {
    return;
  }

  const gridRow: GridItemType = gridController.view.dom.$grid.getEventContext(event).item;

  if (isEmpty(gridRow)) {
    return;
  }

  gridController.view.dom.$grid.selectItem(gridRow);
  const { pageX, pageY } = event as unknown as MouseEvent;

  gridController.component.dispatchEvent(
    new RowRightClickEvent(GridEvents.ROW_RIGHT_CLICKED, {
      detail: {
        coords: {
          x: pageX,
          y: pageY,
        },
        selectedItems: gridController.view.dom.$grid.selectedItems,
        rowIndex: gridController.view.dom.$grid.getEventContext(event).index,
      },
    })
  );
}
